import { ExamDetail } from '@ats/api/cm';
import gql from 'graphql-tag';

export const CREATE_EXAM_QUERY = gql`
	mutation ($request: CreateExamRequest!) {
		createExam(request: $request) {
			id
			cmcId
			examAuthId
		}
	}
`;

export type CreateExamResponse = Pick<ExamDetail, 'id' | 'cmcId' | 'examAuthId'>;
export type CreateExamMutationResponse = { createExam: CreateExamResponse | null };
